import { Box, Skeleton, Stack, Typography } from '@mui/material';
import { TokenFormat } from 'shared/ui';

import { receiveToken } from '../../model';

interface ReceiveProps {
  finalAmount: bigint | undefined;
  bonus: bigint | undefined;
  decimals: number;
  loading: boolean;
}

export const Receive = ({ finalAmount, bonus, decimals, loading }: ReceiveProps) => {
  return (
    <Stack mt={4} alignItems="center" spacing={0.75} mb={3}>
      <Typography variant="body1" className="secondary regular">
        You get
      </Typography>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Box
          component="img"
          src={receiveToken.image}
          alt="CIT token"
          sx={{
            width: 35,
            height: 35,
          }}
        />
        {loading ? (
          <Skeleton variant="text" width={100} height={30} />
        ) : (
          <TokenFormat amount={finalAmount} decimals={decimals} symbol="CIT" variant="h4" className="primary" />
        )}
      </Stack>
      <Typography variant="body1" textAlign="center" className="secondary regular">
        Including <Box component="br" display={{ xs: 'block', sm: 'none' }} />
        <TokenFormat
          className="accent"
          amount={loading ? undefined : bonus}
          decimals={decimals}
          symbol="CIT bonus"
          fallback="0.00 CIT bonus"
          maxDecimalDigits={2}
        />
      </Typography>
    </Stack>
  );
};
